"use client";

import { cn } from "@/utils";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { Toast, ToastProvider } from "./toast";
import { ToastClose } from "./toast-close";
import { ToastDescription } from "./toast-description";
import { ToastTitle } from "./toast-title";
import { ToastViewport } from "./toast-viewport";
import { useToast } from "./use-toast";

export type toastVariants = "success" | "error" | "destructive" | "info";

const MAP_TOAST_ICON: Record<toastVariants, React.ReactNode> = {
  success: <CheckCircle2 className="h-4 w-4 text-green-600 mt-[2px]" />,
  error: <AlertCircle className="h-4 w-4 text-red-500 mt-[2px]" />,
  destructive: <AlertCircle className="h-4 w-4 text-yellow-500 mt-[2px]" />,
  info: <AlertCircle className="h-4 w-4 text-gray-500 mt-0.5" />,
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="left">
      {toasts.map(function ({ id, title, description, icon, action, ...props }) {
        return (
          <Toast key={id} {...props} className="">
            <div className="grid gap-1 py-3">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription
                  className={cn("flex items-start gap-2 text-sm")}
                  variant={props.variant}
                >
                  {MAP_TOAST_ICON[props.variant as toastVariants] || icon}
                  <span className="text-sm font-medium">{description}</span>
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport className="h-fit z-[100] !top-0" />
    </ToastProvider>
  );
}
